/**
 * Converts a UTC timestamp to a local datetime format for input fields
 * @param {string} utcString - UTC timestamp in ISO format
 * @returns {string} - Datetime string in format YYYY-MM-DDTHH:MM:SS
 */
export const utcToLocalDatetimeInput = (utcString) => {
	const date = new Date(utcString);

	const pad = (num) => num.toString().padStart(2, '0');

	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
		date.getDate()
	)}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
		date.getSeconds()
	)}`;
};

/**
 * Converts a local datetime to UTC format
 * @param {string} localDateTime - Local datetime string
 * @returns {string} - UTC datetime string in ISO format
 */
export const localToUTC = (localDateTime) => {
	const localDate = new Date(localDateTime);
	return localDate.toISOString();
};

/**
 * Formats a date for display
 * @param {string} dateString - Date string to format
 * @param {boolean} includeTime - Whether to include time
 * @returns {string} - Formatted date string
 */
export const formatDate = (dateString, includeTime = true) => {
	const date = new Date(dateString);

	const options = {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	};

	if (includeTime) {
		options.hour = 'numeric';
		options.minute = 'numeric';
	}

	return date.toLocaleDateString(undefined, options);
};

/**
 * Gets the status of a dialogue based on its start and end times
 * @param {string} startTime - Start time string
 * @param {string} endTime - End time string
 * @returns {object} - Object with status string and className for styling
 */
export const getDialogueStatus = (startTime, endTime) => {
	const now = Date.now();
	const startDate = new Date(startTime).getTime();
	const endDate = new Date(endTime).getTime();

	if (now < startDate) {
		return { status: 'Not Started', className: 'badge-secondary' };
	} else if (now > endDate) {
		return { status: 'Expired', className: 'badge-danger' };
	} else {
		return { status: 'Active', className: 'badge-primary' };
	}
};
